import { useState, useEffect, useMemo } from "react";
import type { TWRChart } from "@/schemas";
import { getTWRChart } from "../services/portfolio-service";

interface UseMaxTWRDataResult {
  maxTwrData: TWRChart | null;
  loading: boolean;
  cagr: number | null;
}

/**
 * Hook to fetch TWR data for "max" period to get all-time CAGR.
 * This data never changes with user period selection.
 */
export function useMaxTWRData(selectedBookId: string): UseMaxTWRDataResult {
  const [maxTwrData, setMaxTwrData] = useState<TWRChart | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMaxTwr = async () => {
      setLoading(true);
      const twrRes = await getTWRChart(selectedBookId, "max");
      setMaxTwrData(twrRes);
      setLoading(false);
    };
    fetchMaxTwr();
  }, [selectedBookId]);

  const cagr = useMemo(() => {
    return maxTwrData?.annualized_return_since_inception ?? null;
  }, [maxTwrData]);

  return { maxTwrData, loading, cagr };
}
